export default __webpack_public_path__ + "static/media/icon_IG.de7fabc3.png";